import { useLanguage } from "@/components/LanguageContext";
import { Reveal, Eyebrow } from "@/components/Reveal";

const Prozess = () => {
  const { t } = useLanguage();
  return (
    <section id="prozess" className="bg-dark py-20 lg:py-28">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Reveal>
              <Eyebrow>{t.prozess.eyebrow}</Eyebrow>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-4 font-display text-4xl font-medium tracking-tight sm:text-5xl">
                {t.prozess.title}
              </h2>
            </Reveal>
          </div>
          <div className="grid grid-cols-1 gap-x-12 gap-y-12 sm:grid-cols-2 lg:col-span-8">
            {t.prozess.steps.map((s, i) => (
              <Reveal key={s.k} delay={0.1 + i * 0.08}>
                <div data-testid={`prozess-step-${i + 1}`} className="relative border-l border-bone/10 pl-8">
                  <span
                    className="absolute -left-[4px] top-1.5 h-[7px] w-[7px] rounded-full bg-gold shadow-[0_0_10px_rgba(61,158,255,0.9)]"
                    aria-hidden="true"
                  />
                  <span className="font-mono text-xs tracking-[0.25em] text-gold">[ {String(i + 1).padStart(2, "0")} ]</span>
                  <h3 className="mt-3 font-mono text-sm font-medium uppercase tracking-[0.25em]">{s.k}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-inkmuted">{s.copy}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Prozess;
